import { Checkbox, Radio, Select, Space } from "antd";
import {
  InvestmentMatchReviewFamily,
  InvestmentMatchReviewRequest,
  InvestmentReportDatasetType,
} from "../../entities/investmentReview";

interface Props {
  filters: InvestmentMatchReviewRequest;
  onChange: (request: InvestmentMatchReviewRequest) => void;
}

const datasetOptions = [
  { value: InvestmentReportDatasetType.IndustrySummary, label: "خلاصه صنایع" },
  { value: InvestmentReportDatasetType.ListedPortfolio, label: "پرتفوی بورسی" },
  { value: InvestmentReportDatasetType.UnlistedPortfolio, label: "پرتفوی خارج بورس" },
  { value: InvestmentReportDatasetType.AcquiredShares, label: "سهام تحصیل‌شده" },
  { value: InvestmentReportDatasetType.DisposedShares, label: "سهام واگذارشده" },
  { value: InvestmentReportDatasetType.DividendIncome, label: "سود سهام" },
];

export const InvestmentReviewFilters = ({ filters, onChange }: Props) => (
  <Space direction="vertical" style={{ width: "100%" }} size="middle">
    <div>
      <div className="mb-1 text-xs text-slate-500">نوع هویت</div>
      <Select
        allowClear
        style={{ width: "100%" }}
        value={filters.family}
        placeholder="همه"
        options={[
          { value: InvestmentMatchReviewFamily.CompanyLike, label: "شرکت / سرمایه‌پذیر" },
          { value: InvestmentMatchReviewFamily.Industry, label: "صنعت سرمایه‌گذاری" },
        ]}
        onChange={(family) => onChange({ ...filters, pageNumber: 1, family, datasetType: undefined })}
      />
    </div>

    <div>
      <div className="mb-1 text-xs text-slate-500">Dataset</div>
      <Select
        allowClear
        style={{ width: "100%" }}
        value={filters.datasetType}
        placeholder="همه"
        options={datasetOptions.filter((x) =>
          filters.family === InvestmentMatchReviewFamily.Industry
            ? x.value === InvestmentReportDatasetType.IndustrySummary
            : filters.family === InvestmentMatchReviewFamily.CompanyLike
              ? x.value !== InvestmentReportDatasetType.IndustrySummary
              : true,
        )}
        onChange={(datasetType) => onChange({ ...filters, pageNumber: 1, datasetType })}
      />
    </div>

    <div>
      <div className="mb-1 text-xs text-slate-500">فقط گروه‌های خارج بورس</div>
      <Radio.Group
        value={filters.isUnlistedOnly === undefined ? "all" : filters.isUnlistedOnly ? "yes" : "no"}
        onChange={(e) =>
          onChange({
            ...filters,
            pageNumber: 1,
            isUnlistedOnly: e.target.value === "all" ? undefined : e.target.value === "yes",
          })
        }>
        <Radio value="all">همه</Radio>
        <Radio value="yes">بله</Radio>
        <Radio value="no">خیر</Radio>
      </Radio.Group>
    </div>

    <div className="flex flex-col gap-2">
      <Checkbox
        checked={filters.includeUnmatched}
        onChange={(e) => onChange({ ...filters, pageNumber: 1, includeUnmatched: e.target.checked })}>
        Unmatched
      </Checkbox>
      <Checkbox
        checked={filters.includeNeedsReview}
        onChange={(e) => onChange({ ...filters, pageNumber: 1, includeNeedsReview: e.target.checked })}>
        Needs Review
      </Checkbox>
    </div>
  </Space>
);
